<template>
  <div class="receipt-detail-drawer">
    <finance-drawer
      title="应付单详情"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="payableNo"
      :modal-close="false"
      @refresh="handleOpen"
    >
      <div v-loading="loading">
        <div class="main-cont">
          <div class="main-cont-item">
            <h2 class="title-text">
              基本信息
              <icon-status
                :color="_setStatusColor(detailInfo.approvalStatus, 'cancelStatus')"
                :status="detailInfo.approvalStatusDesc"
              />
            </h2>
            <el-row :gutter="20" style="margin-top: -8px;">
              <jr-col :data-show="firstCol" :data="detailInfo">
                <template #orderNumber>
                  <jr-tooltip :content="detailInfo.orderNumber" type="popover" :is-filter="true" />
                </template>
              </jr-col>
              <jr-col :data-show="secondCol" :data="detailInfo">
                <template #shouldPayAmount>
                  <span class="detail-amount_num">
                    {{ detailInfo.shouldPayAmount | toFenThousandsAndFloat('¥') }}
                  </span>
                  <span style="margin-left: 8px;color: #407DFF;cursor: pointer;" @click="handleLogList" v-if="operationLogList.length">
                    <i class="el-icon-warning-outline" />
                  </span>
                </template>
              </jr-col>
              <jr-col :data-show="thirdCol" :data="detailInfo" />
            </el-row>
          </div>

          <div class="main-cont-item">
            <h2 class="title-text">关联的应收单</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.receiveList || [])"
              :tableColumn="receiveTableColumn"
            />
          </div>
          <div class="main-cont-item">
            <h2 class="title-text">关联的付款单</h2>
            <jr-table
              size="mini"
              :tableData="(detailInfo.paymentList || [])"
              :tableColumn="paymentTableColumn"
            />
          </div>
        </div>
      </div>
    </finance-drawer>

    <!-- 付款单详情 -->
    <payment-detail
      v-if="isPaymentDetailShow"
      :visible.sync="isPaymentDetailShow"
      :payment-no.sync="paymentNo"
    />

    <!-- 操作日志 -->
    <operationLogList :visible.sync="isOperationLogShow" :list="operationLogList" />
  </div>
</template>
<script>
/**
 * 应付单详情
 * 权限值 FWS-SFKGL-YFD-XQ
 */
import { getPaymentPayableDetail, getOperationLogList } from '@/api/approval/payment-apply';
import { setStatusColor } from '@/filters/index';
import operationLogList from '@/components/pageComponents/operationLogList';

export default {
  name: 'paymentPayableDetail',
  props: {
    payableNo: {
      type: String,
      default: '',
    },
  },
  components: {
    paymentDetail: () => import('../payment/components/detail'),
    operationLogList,
  },
  data() {
    return {
      detailInfo: {},
      loading: false,
      isReceiveDetailShow: false, // 详情弹窗
      receiveNo: '', // 应收单编号
      paymentNo: '', // 付款单编号
      isPaymentDetailShow: false,
      // 基础信息
      firstCol: [
        { label: '客户名称:', prop: 'businessName' },
        { label: '客户编号:', prop: 'businessNo' },
        { label: '业务订单号:', prop: 'orderNumber', slotName: 'orderNumber' },
        { label: '应付单状态:', prop: 'approvalStatusDesc' },
      ],
      secondCol: [
        { label: '应付金额:', prop: 'shouldPayAmount', slotName: 'shouldPayAmount' },
        { label: '实付金额:', prop: 'realPayAmount', filters: 'toFenThousandsAndFloat' },
        { label: '已退金额:', prop: 'refundAmount', filters: 'toFenThousandsAndFloat' },
        { label: '应付类型:', prop: 'typeDesc' },
      ],
      thirdCol: [
        { label: '归属业务:', prop: 'sourceDesc' },
        { label: '业务BD:', prop: 'bdName' },
        { label: '创建时间:', prop: 'crtime', filters: 'formatTime' },
      ],
      isOperationLogShow: false,
      operationLogList: [],
    };
  },
  computed: {
    // 应收单表格
    receiveTableColumn() {
      const list = [
        { label: '应收单编号', prop: 'receiveNo' },
        { label: '业务订单编号', prop: 'orderNumber' },
        { label: '客户名称', prop: 'businessName' },
        { label: '客户编号', prop: 'businessNo' },
        { label: '应收类型', prop: 'typeDesc' },
        {
          label: '应收金额',
          prop: 'shouldRecAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '实收金额',
          prop: 'realAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '待收金额',
          prop: 'waitRecAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '状态',
          status: 'status',
          statusDesc: 'statusDesc',
          statusColor: (val) => this._setStatusColor(val, 'cancelStatus'),
        },
      ];
      return list;
    },
    // 付款单表格
    paymentTableColumn() {
      const list = [
        {
          label: '付款单编号',
          prop: 'paymentNo',
          permission: 'FWS-SFKGL-FKD-XQ',
          click: (row) => {
            this.handlePaymentDetail(row);
          },
        }, {
          label: '付款单类型',
          prop: 'typeDesc',
        }, {
          label: '付款方式',
          prop: 'payModeDesc',
        }, {
          label: '付款渠道',
          prop: 'payWayDesc',
        }, {
          label: '付款金额',
          prop: 'payAmount',
          filterName: 'toFenThousandsAndFloat',
        }, {
          label: '付款时间',
          prop: 'payTime',
          filterName: 'formatTime',
        }, {
          label: '付款原因',
          prop: 'payReason',
        }, {
          label: '状态',
          status: 'payStatus',
          statusDesc: 'payStatusDesc',
          statusColor: (val) => this._setStatusColor(val, 'paymentStatus'),
        },
      ];
      return list;
    },
  },
  watch: {
    payableNo: {
      deep: true,
      handler() {
        if (this.payableNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    _setStatusColor(val, type) {
      return setStatusColor(val, type);
    },
    // 应收单详情
    handleReceiveDetail(row) {
      this.receiveNo = row?.receiveNo || '';
      this.isReceiveDetailShow = true;
    },
    handlePaymentDetail(row) {
      this.paymentNo = row?.paymentNo || '';
      this.isPaymentDetailShow = true;
    },
    // 打开窗口前
    handleOpen() {
      this.operationLogList = [];
      this.$nextTick(async () => {
        this.isReceiveDetailShow = false;
        this.isPaymentDetailShow = false;
        await this.getPaymentPayableDetail(this.payableNo);
        this.getLogList();
      });
    },
    // 获取付款管理详情接口
    async getPaymentPayableDetail(payableNo) {
      try {
        if (!this.payableNo) {
          this.$message.warning('应付单编号不能为空！！');
          return;
        }
        this.loading = true;
        const res = await getPaymentPayableDetail({ payableNo });
        this.detailInfo = res.data || {};
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.detailInfo = {};
        console.log(error);
      }
    },
    // 获取操作日志
    async getLogList() {
      try {
        const res = await getOperationLogList({ orderNumber: this.detailInfo.orderNumber });
        this.operationLogList = res.data || [];
      } catch (error) {
        console.log(error);
      }
    },
    // 查看日志
    handleLogList() {
      this.isOperationLogShow = true;
    },
  },
};
</script>

